import Image from 'next/image'
import Link from 'next/link'

export default function ALogo({ onLinkClick }: { onLinkClick: () => void }) {
	return (
		<div className='header__logo'>
			<Link href='/' title='Domov' onClick={onLinkClick} prefetch={true}>
				<Image
					unoptimized={true}
					src='/assets/images/medante-logo-dark.svg'
					alt='Medante'
					width={431}
					height={115}
					priority
					fetchPriority='high'
				/>
			</Link>
		</div>
	)
}
